import { Col, Row } from "antd";
import styles from "./VenueImage.module.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import venueImg from "../../../../../../assets/venueImg.png";
import { useLocation } from "react-router-dom";

const VenueImage = () => {
  const { state } = useLocation();
  return (
    <Row>
      <Col xs={24}>
        <Row className={styles.iconRow}>
          <div className={styles.iconBtn}>
            <RiDeleteBin6Line />
          </div>
        </Row>
        <Row className={styles.imageRow} style={{backgroundImage:`url(${state?.venuImage})`}}>
          {/* <img
            src={state?.venuImage ? state?.venuImage : venueImg}
            alt=""
            className={styles.image}
          /> */}
        </Row>
      </Col>
    </Row>
  );
};

export default VenueImage;
